export default __webpack_public_path__ + "beta-maps-example-point-annotation-960-675289c49c2cf6f91e98954b923bc7a3.png";